export const WarningIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        data-testid="warningIcon"
    >
        <path
            d="M4.57187 18L4 19H5.15313H18.85H20.0031L19.4312 18L12.575 6.00625L12 5L11.425 6.00625L4.57187 18ZM18.2781 18H5.72187L12 7.01562L18.2781 18ZM11.5 14V14.5H12.5V14V10H11.5V14ZM12.75 17V15.5H11.25V17H12.75Z"
            fill="#FAB000"
        />
    </svg>
);
